import React from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { IGroupDetailed } from '../../../types/group'
import { push } from '../../../actions/router'
import * as date from '../../../services/date'
import { H3, P, TooltipedChip } from '../../../components'
import { GroupCapabilitiesList } from '../GroupCapabilitiesList'
import { StyledTableRow } from './styled'

interface IAllGroupsTableRowComponent {
  group: IGroupDetailed
  dispatch: Dispatch
}

const AllGroupsTableRowComponent = ({
  group,
  dispatch,
}: IAllGroupsTableRowComponent) => (
  <StyledTableRow
    onClick={() => dispatch(push(`/settings/groups/${group.name}?tab=details`))}
  >
    <td>
      <div>
        <H3>
          {group.shortTitle}{' '}
          {group.hidden && (
            <TooltipedChip
              size="small"
              label="Hidden"
              tooltipTitle={
                "Hidden groups won't be visible in Consumer portal. " +
                'Only these users who have permission to this hidden group could access it.'
              }
              disabled
            />
          )}
        </H3>
        <P>{group.title}</P>
      </div>
    </td>
    <td>
      <GroupCapabilitiesList capabilities={group.capabilities || []} />
    </td>
    <td />
    <td>
      <P>{date.calendar(group.modified || group.created)}</P>
    </td>
    <td />
  </StyledTableRow>
)

export const AllGroupsTableRow = connect()(AllGroupsTableRowComponent)
